import { render, staticRenderFns } from "./configModal.vue?vue&type=template&id=9fbf047a&scoped=true&"
import script from "./configModal.vue?vue&type=script&lang=js&"
export * from "./configModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbf047a",
  null
  
)

export default component.exports